// extracted by mini-css-extract-plugin
module.exports = {"marketometerTable":"CompetitivenessTable_marketometerTable__1zLw6","brandName":"CompetitivenessTable_brandName__15tuw","dot":"CompetitivenessTable_dot__2BsyQ"};